import "jquery";

export class Header {
    init(): void {
        const isBurgerMenu = $('.navigation-shop').css("position") === "fixed";
        let isTouchDevice = false; //initiate as false

        if (isBurgerMenu) {
            $('.btn-collapse').on('click', function () {
                $(this).parent('li').toggleClass('open');
            });



            $('.navigation-icon[data-toggle="dropdown"]').on('click', function () {
                if ($(this).parent().hasClass('show')) {
                    $(document.body).removeClass('no-scroll');
                }
                else {
                    $(document.body).addClass('no-scroll');
                }
            });
        }

        $(document).on('click', '.header .dropdown-menu', function (e) {
            e.stopPropagation();
        });
    }
}